// pages/ReporteManifiestoTrackingPage.js o donde desees usarlo
import React from 'react';
import { Box } from '@mui/material';
import ManifestTrackingReportDashboard from '../../components/report/ManifestTrackingReportDashboard';

const ReporteManifiestoTrackingPage = () => {
    return (
        <Box sx={{ p: 2 }}>
            <ManifestTrackingReportDashboard
                onReorder={(newOrder) => {
                    console.log('Nuevo orden de reporte de tracking de manifiesto', newOrder);
                }}
            />
        </Box>
    );
};

export default ReporteManifiestoTrackingPage;
